import { UsuarioAttributes } from "@fl/shared/src/types/models/suporte_fl/usuarios";
import { yupResolver } from "@hookform/resolvers/yup";
import React, { useState } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import { SubmitHandler, useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { usuarioSchema } from "../../schemas/users";
import ApiUsers from "../../services/suporte/users";
import DefaultBasePage from "../default/base"; // ajuste o caminho conforme necessário

export type UsuarioFormInputs = Omit<
  UsuarioAttributes,
  | "id_usuario"
  | "createdAt"
  | "updatedAt"
  | "id_grupo_permissao"
  | "ativo"
  | "codigo"
  | "expiracao"
  | "banido"
  | "master"
> & {
  confirmarSenha: string;
};

const CreateUserPage: React.FC = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm<UsuarioFormInputs>({
    resolver: yupResolver(usuarioSchema),
  });

  const onSubmit: SubmitHandler<UsuarioFormInputs> = async (data) => {
    try {
      setLoading(true);
      const result = await new ApiUsers(data).create();
      navigate("/", { state: result });
    } finally {
      setLoading(false);
    }
  };

  const handleReset = () => {
    reset();
  };

  return (
    <DefaultBasePage title="Criar Usuário" loading={loading}>
      <div className="d-flex justify-content-center">
        <Form onSubmit={handleSubmit(onSubmit)} noValidate>
          <Row className="mt-2">
            <Col className="mt-1">
              <Form.Group controlId="formNome">
                <Form.Label>Nome Completo:</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Digite o nome"
                  {...register("nome")}
                  isInvalid={!!errors.nome}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.nome?.message}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>

            <Col className="mt-1">
              <Form.Group controlId="formEmail">
                <Form.Label>E-mail:</Form.Label>
                <Form.Control
                  type="email"
                  placeholder="Digite o e-mail"
                  {...register("email")}
                  isInvalid={!!errors.email}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.email?.message}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
          </Row>

          <Row className="mt-3">
            <Col className="mt-1">
              <Form.Group controlId="formSenha">
                <Form.Label>Senha:</Form.Label>
                <Form.Control
                  type="password"
                  placeholder="Digite a senha"
                  {...register("senha")}
                  isInvalid={!!errors.senha}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.senha?.message}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
            <Col className="mt-1">
              <Form.Group controlId="formConfirmarSenha">
                <Form.Label>Confirmar Senha:</Form.Label>
                <Form.Control
                  type="password"
                  placeholder="Confirme a senha"
                  {...register("confirmarSenha")}
                  isInvalid={!!errors.confirmarSenha}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.confirmarSenha?.message}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
          </Row>

          <div className="d-flex justify-content-between">
            <Button
              variant="outline-danger"
              type="submit"
              className="mt-4"
              onClick={handleReset}
            >
              Limpar Dados
            </Button>
            <Button variant="outline-success" type="submit" className="mt-4">
              Cadastrar Usuário
            </Button>
          </div>
        </Form>
      </div>
    </DefaultBasePage>
  );
};

export default CreateUserPage;
